import { __awaiter, __generator } from 'tslib';
import preloadedPublisherConfigs from '../data/index.js';

/**
 * Loads a publisher configuration from its JSON file or non-affiliate configurations
 *
 * @param domain The domain name of the publisher
 * @returns Promise resolving to the publisher configuration
 * @throws Error if the configuration cannot be loaded
 */
function loadPublisherConfiguration(domain) {
    return __awaiter(this, void 0, void 0, function () {
        var preloadedConfig, config, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    preloadedConfig = preloadedPublisherConfigs[domain];
                    if (preloadedConfig) {
                        return [2 /*return*/, preloadedConfig];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, import("@highereducation/edu-product-toolkit-publishers/dist/data/publishers/".concat(domain, "/config.json"))];
                case 2:
                    config = _a.sent();
                    // Return just the imported config
                    return [2 /*return*/, config];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [2 /*return*/, preloadedPublisherConfigs['default']];
                case 4: return [2 /*return*/];
            }
        });
    });
}

export { loadPublisherConfiguration };
